import PropTypes from "prop-types";
import { classNamePropType } from "../../common";

/**
 * PropTypes for AppFooter component
 *
 * @property {string} [className] - Additional CSS classes
 * @property {string} [copyright] - Copyright text
 * @property {Array<{label: string, href: string}>} [links] - Footer links
 */
export const appFooterPropTypes = {
  className: classNamePropType,
  copyright: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ),
};
